type GapiType = typeof gapi;
type ResolveGapi = () => GapiType;

//https://developers.google.com/identity/sign-in/web/reference#gapiauth2authorizeresponse
export type AuthorizeResponse = {
  access_token?: string;
  id_token?: string;
  code?: string;
  scope?: string;
  expires_in?: number;
  first_issued_at?: number;
  expires_at?: number;
  error?: string;
  error_subtype?: string;
};

class GoogleOauthService {
  private readonly resolveGapi: ResolveGapi;
  private readonly clientId: string;

  constructor({ resolveGapi, clientId }: { resolveGapi: ResolveGapi; clientId: string }) {
    this.resolveGapi = resolveGapi;
    this.clientId = clientId;

    this.initialize();
  }

  // default to webmaster but could be used for other services
  public async authenticate(scope = 'https://www.googleapis.com/auth/webmasters profile'): Promise<AuthorizeResponse> {
    return new Promise((resolve, reject) => {
      this.resolveGapi().load('auth2', () => {
        this.resolveGapi().auth2.authorize(
          {
            client_id: this.clientId,
            scope: scope,
            response_type: 'code',
            prompt: 'select_account',
            include_granted_scopes: true,
          },
          function (response: AuthorizeResponse) {
            if (response.error) {
              console.warn(response.error);
              reject(new Error('Google authentication is canceled'));
            }
            resolve(response);
          },
        );
      });
    });
  }

  private initialize() {
    const api = this.resolveGapi();
    if (!api) {
      throw new Error('googleapi SDK is not loaded.');
    }
  }
}

export default GoogleOauthService;
